var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "address-title" },
    [
      _c("div", { staticClass: "pre-title" }, [_vm._t("default")], 2),
      _vm._v(" "),
      _c("img", {
        staticClass: "title_icon copy __pointer",
        attrs: { src: require("assets/imgs/copy_default.svg") },
        on: { click: _vm.copy }
      }),
      _vm._v(" "),
      _c(
        "span",
        {
          directives: [
            {
              name: "click-outside",
              rawName: "v-click-outside",
              value: _vm.closeQrCode,
              expression: "closeQrCode"
            }
          ],
          ref: "codeContainer",
          staticClass: "title_icon __pointer qrcode"
        },
        [
          _c("img", {
            attrs: { src: require("assets/imgs/qrcode_default.svg") },
            on: { click: _vm.toggleQrCode }
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.qrcodeShow,
                  expression: "qrcodeShow"
                }
              ],
              staticClass: "code-container"
            },
            [
              _c("qrcode", {
                attrs: { text: _vm.addressQrcode, options: { size: 146 } },
                on: { genImage: _vm.getImage }
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "btn", on: { click: _vm.downLoadQrCode } },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t("saveQrcode")) +
                      "\n            "
                  )
                ]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c("copy", { ref: "copyDom", staticClass: "copy-wrapper" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }